import { useState } from 'react'

import { useMutation } from '@redwoodjs/web'

import DNButton from 'src/components/Buttons/Button/DNButton'
import {
  DELETE_DOCUMENT_TEMPLATE_PACKAGE,
  GET_DOCUMENT_TEMPLATE_PACKAGES,
} from 'src/graphql/documentTemplatePackages.graphql'

import SettingsField from '../../../components/SettingsField'

const DeletePackage = ({ pkg, setSelectedPackageId }) => {
  const [confirmDelete, setConfirmDelete] = useState(false)

  const [deletePackage] = useMutation(DELETE_DOCUMENT_TEMPLATE_PACKAGE, {
    refetchQueries: [GET_DOCUMENT_TEMPLATE_PACKAGES],
    onCompleted: () => setSelectedPackageId(null),
  })

  const handleDelete = () => {
    deletePackage({
      variables: { documentTemplatePackageId: pkg.documentTemplatePackageId },
    })
  }

  return (
    <SettingsField
      title="Delete Package"
      description="Delete the package and remove all associated documents."
    >
      {confirmDelete ? (
        <div className="flex flex-row gap-2">
          <DNButton variant="secondary" onClick={() => setConfirmDelete(false)}>
            Cancel
          </DNButton>
          <DNButton variant="error" onClick={handleDelete}>
            Confirm deletion
          </DNButton>
        </div>
      ) : (
        <DNButton variant="secondary" onClick={() => setConfirmDelete(true)}>
          Delete Package
        </DNButton>
      )}
    </SettingsField>
  )
}

export default DeletePackage
